export default "__VITE_ASSET__BQgWVstF__"